import underline from "../media/pen-underline.png";
import Nav from "../components/nav";
import FooterComp from "../components/footer";
import "../css/contact.css";
import { useNavigate } from "react-router-dom";
import useGenStore from "../store/store";
import Fonav from "../components/fonnav";
import "aos/dist/aos.css";
import Aos from "aos";
import { useEffect, useRef, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { Ping } from 'ldrs/react';
import 'ldrs/react/Ping.css';

function Contact() {
  const menuActive = useGenStore((s) => s.menuActive);
  const navigate = useNavigate();
  const contactSectionRef = useRef(null);

  // Form refs
  const nameRef = useRef("");
  const emailRef = useRef("");
  const phoneRef = useRef("");
  const caseRef = useRef("");

  // State
  const [captchaToken, setCaptchaToken] = useState(null);
  const captchaRef = useRef();
  const [loader, setLoader] = useState(false);
  const [errors, setErrors] = useState({
    name: "",
    email: "",
    phone: "",
    case: "",
  });

  const toContact = () => {
    navigate("/contact");
  };

useEffect(() => {
  const wakeUpBackend = async () => {
    try {
      // Replace with your actual backend URL
      const response = await axios.post("https://mccanna-law-backend.onrender.com/hello");
      console.log("Backend is awake:", response.data);
    } catch (error) {
      console.log("Backend wake-up failed:", error.message);
    }
  };
  
  // Initial wake-up
  wakeUpBackend();
  
  // Optional: Keep waking up every 10 minutes (600,000 ms)
  const interval = setInterval(wakeUpBackend, 600000);
  
  return () => clearInterval(interval);
}, []);
  useEffect(() => {
    Aos.init({ duration: 400 });

    if (contactSectionRef.current) {
      contactSectionRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }, []);

  const validateForm = () => {
    let valid = true;
    const newErrors = {
      name: "",
      email: "",
      phone: "",
      case: "",
    };

    // Name validation
    const nameValue = nameRef.current.value.trim();
    if (!nameValue) {
      newErrors.name = "Name is required";
      valid = false;
    } else if (nameValue.length < 2) {
      newErrors.name = "Name must be at least 2 characters";
      valid = false;
    }

    // Email validation
    const emailValue = emailRef.current.value.trim();
    if (!emailValue) {
      newErrors.email = "Email address is required";
      valid = false;
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailValue)) {
      newErrors.email = "Enter a valid email address";
      valid = false;
    }

    // Phone validation
    const phoneValue = phoneRef.current.value.trim();
    if (!phoneValue) {
      newErrors.phone = "Phone number is required";
      valid = false;
    } else if (!/^[\d\s\-\(\)\+]+$/.test(phoneValue)) {
      newErrors.phone = "Enter a valid phone number";
      valid = false;
    } else if (phoneValue.replace(/[\s\-\(\)\+]/g, '').length < 10) {
      newErrors.phone = "Phone number must have at least 10 digits";
      valid = false;
    }

    // Case description validation
    const caseValue = caseRef.current.value.trim();
    if (!caseValue) {
      newErrors.case = "Case description is required";
      valid = false;
    } else if (caseValue.length < 20) {
      newErrors.case = "Please provide more detail (at least 20 characters)";
      valid = false;
    }

    setErrors(newErrors);
    return valid;
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;

 

    const name = nameRef.current.value;
    const email = emailRef.current.value;
    const phone = phoneRef.current.value;
    const caseDesc = caseRef.current.value;

    const url = "https://mccanna-law-backend.onrender.com/sendEmail";

    const body = `

Name: ${name}
Email: ${email}
Phone: ${phone}

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
CASE DETAILS
━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
${caseDesc}
`;

    const data = {
      emUser: email,
      nameUser: name,
      subject: `New Consultation Request from ${name}`,
      body: body,
      captcha: captchaToken,
    };

    setLoader(true);

    try {
      const response = await axios.post(url, data, {
        timeout: 30000,
        headers: {
          'Content-Type': 'application/json',
        },
      });

      setLoader(false);

      Swal.fire({
        title: "Message Sent!",
        text: response.data.message || "Your message has been sent. We will contact you shortly.",
        icon: "success",
        confirmButtonColor: "#CCF41C",
        confirmButtonText: "Sounds Good!",
      });

      // Reset form
      if (nameRef.current) nameRef.current.value = "";
      if (emailRef.current) emailRef.current.value = "";
      if (phoneRef.current) phoneRef.current.value = "";
      if (caseRef.current) caseRef.current.value = "";

      if (captchaRef.current) {
        captchaRef.current.reset();
      }
      setCaptchaToken(null);

    } catch (error) {
      setLoader(false);

      let errorMessage = "Failed to send message. Please try again.";

      if (error.response) {
        errorMessage = error.response.data?.message || errorMessage;
      } else if (error.request) {
        errorMessage = "Network error. Please check your connection and try again.";
      }

      Swal.fire({
        title: "Error",
        text: errorMessage,
        icon: "error",
        confirmButtonColor: "#CCF41C",
        confirmButtonText: "Try Again",
      });
    }
  };

  const onCaptchaChange = (token) => {
    setCaptchaToken(token);
  };

  const onCaptchaExpired = () => {
    setCaptchaToken(null);
    Swal.fire({
      title: "Verification Expired",
      text: "Please verify again that you're not a robot.",
      icon: "info",
      confirmButtonColor: "#CCF41C",
      confirmButtonText: "OK",
    });
  };

  return (
    <div>
      <helmet>
        <title>Contact James McCanna | Employment Law Attorney | Free Consultation</title>
        <meta
          name="description"
          content="Contact employment law attorney James McCanna. Schedule a confidential consultation. Serving workers and employers in WA and AK."
        />
      </helmet>

      <div className={`floatNav ${menuActive ? "floatNavActive" : ""}`}>
        <Fonav />
      </div>
      
      <div className="IntroPage">
        <nav>
          <Nav />
        </nav>
        <div className="introWrap">
          <h2>Contact</h2>
          <img src={underline} alt="" />
        </div>
      </div>

      <section className="miniInroContact">
        <div className="mic">
          <h3>
            I'm here to <span>serve you</span>
          </h3>
          <p>
            Send me a message to schedule a confidential consultation. I'll be
            happy to discuss your situation and determine the best next steps.
          </p>
        </div>
      </section>

      <section className="contact" ref={contactSectionRef}>
        <div className="contactForm">
          <div className="contactCont">
            <div className="contactInputCont">
              <p>
                Name<span>*</span>
              </p>
              <div className="contactInputContWrap">
                <input type="text" ref={nameRef} placeholder="Full name" />
              </div>
              {errors.name && <div className="error-text">{errors.name}</div>}
            </div>

            <div className="contactInputCont">
              <p>
                Email<span>*</span>
              </p>
              <div className="contactInputContWrap">
                <input type="email" ref={emailRef} placeholder="Enter email" />
              </div>
              {errors.email && <div className="error-text">{errors.email}</div>}
            </div>

            <div className="contactInputCont">
              <p>
                Phone<span>*</span>
              </p>
              <div className="contactInputContWrap">
                <input type="tel" ref={phoneRef} placeholder="(123) 456-7890" />
              </div>
              {errors.phone && <div className="error-text">{errors.phone}</div>}
            </div>

            <div className="contactInputCont">
              <p>
                Briefly explain your case<span>*</span>
              </p>
              <div className="contactTextContWrap">
                <textarea
                  ref={caseRef}
                  placeholder="Please describe your case. (Minimum 20 characters)"
                  rows="5"
                ></textarea>
              </div>
              {errors.case && <div className="error-text">{errors.case}</div>}
            </div>

            <div className="captcha-container">
             
            </div>

            <button onClick={handleSubmit} disabled={loader}>
              {loader ? <Ping size="30" speed="1" color="#CCF41C" /> : "Submit Message"}
            </button>
          </div>
        </div>
      </section>

      <footer>
        <FooterComp />
      </footer>
    </div>
  );
}

export default Contact;